module.exports = __webpack_public_path__ + "static/media/temporary-living.189da395.jpg";